/* eslint-disable no-new */
import React from 'react'
import ReactDOM from 'react-dom'
import App from './containers/App'
import reportWebVitals from './reportWebVitals'
import moment from 'moment'
import { IS_PROD, PACKAGES } from './config'
import { GlobalProvider } from './contexts/GlobalContext'
import { TAGThemeProvider, CookiesFab } from '@taglivros/tag-components'
import TagManager from 'react-gtm-module'
import ReactPixel from 'react-facebook-pixel'
import { hotjar } from 'react-hotjar'
import ReactGA from 'react-ga'
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
if ( PACKAGES.NEWRELIC_ENABLED !== 'false' ) {
  new BrowserAgent()
}

moment.locale( 'pt-br' )
if ( PACKAGES.GOOGLE_ANALYTICS_ENABLED === 'true' ) {
  ReactGA.initialize( PACKAGES.GOOGLE_ANALYTICS, { 'debug': false } )
}

if ( PACKAGES.HOTJAR_ENABLED === 'true' ) {
  hotjar.initialize( PACKAGES.HOTJAR, 6 )
}

if ( PACKAGES.FACEBOOK_PIXEL_ENABLED === 'true' ) {
  const options = {
    'autoConfig': true,
    'debug': !IS_PROD
  }
  ReactPixel.init( PACKAGES.FACEBOOK_PIXEL, {}, options )
  ReactPixel.pageView()
}

if ( PACKAGES.GOOGLE_TAGMANAGER_ENABLED === 'true' ) {
  setTimeout( () => {
    const tagManagerArgs = {
      'auth': PACKAGES.GTM_CHECKOUT_ENV,
      'gtmId': PACKAGES.GOOGLE_TAGMANAGER_ID,
      'preview': PACKAGES.GTM_CHECKOUT_PREVIEW
    }

    TagManager.initialize( tagManagerArgs )
  }, 7500 )
}

ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      <TAGThemeProvider>
        <App />
      </TAGThemeProvider>

      <CookiesFab />
    </GlobalProvider>,
  </React.StrictMode>,
  document.getElementById( 'root' )
)


reportWebVitals()
